<template>
    <div class="common-goods-list">
        <div class="product-list-header">
            <div class="header-icon"></div>
            <span class="header-title">Top picks for you</span>
            <span class="iconfont"></span>
        </div>
        <div class="goodslist-body show-goods-grid">
            <div class="flex-wrapper" v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                <div class="ui-product-body"
                     v-for='(item, index) in goodsList'
                     v-bind:key='index'
                >
                    <div class="list">
                        <div class="ui-image-wrapper" v-on:click='goDetail(item.goods_id)'>
                            <img class="product-img" v-lazy="item.goods_image_format">
                        </div>
                        <div class="flex-right">
                            <div class="product-header" v-on:click='goDetail(item.goods_id)'>
                                <h3 class="title clear-bottom" style="-webkit-box-orient:vertical">
                                    {{ item.goods_name }}
                                </h3>
                            </div>
                            <div class="p-price" style="-webkit-box-orient:vertical">
                                <span class="price_inorder">${{ item.goods_price }}</span>
                            </div>
                            <div class="p-info">
                                <span class="goods_salenum">Sales {{ item.goods_salenum }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loading-wrapper" v-if="goodsList.length > 0">
                    <p class="common-no-more" v-if='!isMore'>No more</p>
                    <mt-spinner type="triple-bounce" color='#e93b3d' v-if='isMore'></mt-spinner>
                </div>
                <empty-record v-if='goodsList.length <= 0 && !isMore'></empty-record>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import { mapState } from 'vuex'
import { indexSeckillList } from '../../../api/homesearch'
export default {
  name: 'CommonGoodsList',
  props: [],
  components: {
    EmptyRecord
  },
  data () {
    return {
      isShowMore: false, // 是否显示筛选模态框
      params: {
        page: 0,
        token: this.token
      },
      goodsList: [], // 商品列表
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  computed: {
    ...mapState({
      token: state => state.member.token
    })
  },
  created () {

  },
  methods: {
    /*
     * getMore: 无限滚动加载
     */
    getMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getGoodsList(true)
      }
    },
    /**
     * getGoodsList: 获取商品列表
     * @param：  ispush ？ true ：false 是否需要向商品列表追加数据
     */
    getGoodsList (ispush) {
      indexSeckillList(
        this.params, this.token
      ).then(res => {
        this.buildData(ispush, res)
      })
    },
    /**
     * getList: 构建数据
     * @param: ispush 是否改变向元数据追加数据
     * @param: res 接口请求返回的数据
     */
    buildData (ispush, res) {
      if (res) {
        if (ispush) {
          this.goodsList = this.goodsList.concat(res.result.goods_list)
        } else {
          this.goodsList = res.result.goods_list
        }
        this.isMore = res.result.hasmore
      }
    },
    goDetail (goods_id) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': goods_id } })
    }
  }
}
</script>

<style lang='scss' scoped>
    .ui-product-body {
        border-bottom: .045rem solid rgba(232,234,237,1);
        background-color: #fff;
        .list {
            display: flex;
            width: auto;
            align-items: center;
            justify-content: space-between;
            padding: .5rem .45rem;
            position: relative;
            div.ui-image-wrapper {
                width: 5rem;
                height: 5rem;
                position: relative;
                display: flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                flex-basis: 5rem;
                flex-shrink: 0;
                background-position:center center!important;
                background-size:4.54rem 4.54rem;
                background-repeat:no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                img.product-img{
                    width: 5rem;
                    height: 5rem;
                    flex-basis: 5rem;
                    flex-shrink: 0;
                }
                img.product-img[lazy=loading] {
                    width: 1.36rem;
                    height: 1.36rem;
                }
                img.product-im[lazy=error] {
                    width: 1.36rem;
                    height: 1.36rem;
                }
                img.product-img[lazy=loaded] {
                    width: 5rem;
                    height: 5rem;
                    flex-basis: 5rem;
                    flex-shrink: 0;
                    background:rgba(255,255,255,1);
                }
                span {
                    position: absolute;
                    height:.9rem;
                    background:rgba(243,244,245,1);
                    line-height: .9rem;
                    text-align: center;
                    font-size:.63rem;
                    color:$primaryColor;
                    width: 5rem;
                    bottom: 0;
                    left: 0;
                }
            }
            .flex-right {
                width: 100%;
                position:relative;
                .title {
                    color: #333;
                    font-size: .6rem;
                    line-height:1rem;
                    max-height:2rem;
                    font-weight: normal;
                    overflow: hidden;
                    margin-bottom: .4rem;
                    &.clear-bottom {
                        margin-bottom: 0;
                    }
                }
                .product-header {
                    margin-top: .5rem;
                    margin-bottom: .5rem;
                    display: flex;
                    align-items: center;
                }
                .p-price {
                    font-size:0.8rem;
                }
                .p-info {
                  margin-top: 3px;
                    .platform_store_wrapper{
                      /*width:4.2rem;*/
                      display:inline-block;
                    }
                    .platform_store{
                      font-size:.5rem;
                      color: #e93b3d;
                      border: .045rem solid #e93b3d;
                      border-radius: .13rem;
                      padding:.1rem .2rem;
                    }
                    .goods_salenum{
                      font-size:.6rem;
                      color:#999;
                    }
                }
                .add-cart{
                    background: #e93b3d;border-radius: 50%;text-align:center;position: absolute;right: .8rem;bottom:.2rem;width:1.4rem;height:1.4rem;line-height:1.4rem;
                    i{font-size:0.8rem;color:#fff;display:block;}
                }
            }
        }
    }
    .ui-product-body .list .flex-right .p-price .price_inorder{
      color: #111;
      font-weight: bold;
    }
    .ui-product-body .list .flex-right .p-price .price_unit{
      font-size: 12px;
      color: #999;
    }
    .show-goods-grid .loading-wrapper{
      width: 100%;
    }
    .show-goods-grid .flex-wrapper{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }
    .show-goods-grid .flex-wrapper .ui-product-body{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      overflow: hidden;
      /*padding: .5rem;*/
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;
      border-bottom: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
      background-color: #fff;
      width: 50%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .show-goods-grid .flex-wrapper .ui-product-body .list{
      display: block;
    }
    .show-goods-grid .flex-wrapper .ui-product-body .list div.ui-image-wrapper{
      margin: 0 auto;
    }
    .loading-wrapper{
      text-align: center;
    }
    .product-list-header {
      display: flex;
      height: 2rem;
      padding: 0 0.25rem;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
      background: #fff;
      .header-title {
        font-size: 0.8rem;
        color: #333;
        font-weight: 700;
      }
      .header-icon {
        width: 1rem;
        height: 1rem;
      }
    }

</style>
